import { ThemeProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import ProfileSidebar from 'components/organisms/Sidebar/ProfileSidebar';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import FeedBody from './FeedBody';
import GalleryBody from './GalleryBody';
import PaywallBody from './PaywallBody';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const Body = styled(Grid)(({ theme }) => ({
  position: 'relative',
}));

interface IProfileProps {
  currentTab?: string;
  editing?: boolean;
  Feed?: string;
  // setFormData: (value: React.SetStateAction<Partial<UserData>>) => void;
}





const Profile: React.FC<IProfileProps> = (props: any) => {
  const nevigate = useNavigate();
  const handlers = useSwipeable({
    // onSwiped: (eventData) => console.log("User Swiped!", eventData),
    onSwipedLeft: eventData => {
      if (window.innerHeight > window.innerWidth) {
        nevigate(-1);
      }
    },
    // preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });



  return (
    // props.page.gallery ? <GalleryBody /> : props.page.backstage ? <PaywallBody Feed={props.Feed} /> : props.page.feeds ? <FeedBody /> : <></>
    <>
      <React.Fragment>
        <ThemeProvider theme={colortheme}>
          <Body container {...handlers}>
            <Grid container>
              <Grid
                item
                xs={2.5}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '1rem 3rem',
                  [colortheme.breakpoints.down('lg')]: {
                    display: 'none',
                  },
                }}
              >
                <ProfileSidebar editing={props.editing} />
              </Grid>

              <Grid
                item
                xs={12}
                lg={9.5}
                sx={{
                  padding: '1rem 3rem',
                  [colortheme.breakpoints.down('md')]: {
                    padding: '1rem',
                  },
                }}
              >
                {props.currentTab === 'Feed' ? (
                  <GalleryBody />
                ) : props.currentTab === 'Collectors' ? (
                  <PaywallBody isFeed={props.Feed} />
                ) : props.currentTab === 'Splits' ? (
                  <PaywallBody isFeed={props.Feed} />
                ) : props.currentTab === 'Backstage' ? (
                  <FeedBody />
                ) : props.currentTab === 'Badges' ? (
                  <PaywallBody isFeed={props.Feed} />
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Body>
        </ThemeProvider>
      </React.Fragment>
    </>
  );
};

export default Profile;
